module.exports = __webpack_public_path__ + "static/media/Equipment_rent.b335efec.svg";